export const trackingKeys = {
  all: ['trackings'] as const,
  list: () => [...trackingKeys.all, 'list'] as const,
  detail: (id: string) => [...trackingKeys.all, 'detail', id] as const,
  candidates: (trackingId: string) => [...trackingKeys.all, 'candidates', trackingId] as const,
};
